module.exports = __webpack_public_path__ + "img/pt_pt.89b848c2.png";